// Fetch only the selected chapter's map. Its hash prevents an older cached book
// from applying offsets belonging to a different published text.
export async function loadRecordingTimings(recording,chapter,base,cache,fetchFile=fetch){
  if(!recording?.timingDirectory||!chapter)return [];
  const url=new URL(`${recording.timingDirectory}/${encodeURIComponent(chapter.id)}.timings.json`,base).href;
  const key=url+'\n'+chapter.html+'\n'+chapter.title;
  if(cache.has(key))return cache.get(key);
  const pending=(async()=>{
    const response=await fetchFile(url);if(!response.ok)throw Error('Word timings could not be loaded.');
    const data=await response.json();
    const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(chapter.html));
    const hash=[...new Uint8Array(digest)].map(n=>n.toString(16).padStart(2,'0')).join('');
    if(data.htmlHash!==hash||data.title!==chapter.title)throw Error('Word timings belong to a different edition.');
    if(!Array.isArray(data.timings)||!data.timings.every(c=>typeof c.block==='string'&&Number.isInteger(c.offset)&&c.offset>=0&&Number.isFinite(c.start)&&c.start>=0))throw Error('Word timings are invalid.');
    return data.timings;
  })();
  cache.set(key,pending);
  try{return await pending;}catch(error){cache.delete(key);throw error;}
}
